import { useEffect } from 'react';

/**
 * Bidirectional text-highlight sync. Listens for `selectionchange` events,
 * debounces (~200ms), and broadcasts the selected text. Only sends when the
 * selection text actually changes (so deselect → empty broadcast clears it
 * on the peer side).
 *
 * Note: this is a *transient* highlight today — text-content matched, not
 * anchor-stable. Persistent annotations (with stable anchors and Apple
 * Pencil ink) live in iteration D of the live-sessions feature doc.
 */
export function useHighlightSync(perform) {
  useEffect(() => {
    if (!perform) return;

    let lastSent = '';
    let timer;

    const fire = () => {
      const sel = typeof window !== 'undefined' ? window.getSelection() : null;
      const text = sel ? sel.toString().trim() : '';
      if (text === lastSent) return;
      const safe = text.length > 500 ? text.slice(0, 500) : text;
      lastSent = safe;
      perform('highlight', { text: safe });
    };

    const handler = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(fire, 200);
    };

    document.addEventListener('selectionchange', handler);
    return () => {
      document.removeEventListener('selectionchange', handler);
      if (timer) clearTimeout(timer);
    };
  }, [perform]);
}
